import React from 'react';
import { Result } from 'antd';
import { SaleEmbeddedBrowser, useSaleText } from './saleUi';

const SaleBrowserNotice: React.FC<{ browser: SaleEmbeddedBrowser }> = ({ browser }) => {
  const text = useSaleText();
  const name = browser === 'wechat' ? text('微信', 'WeChat') : browser === 'qqBrowser' ? text('QQ 浏览器', 'QQ Browser') : 'QQ';
  return <div className="sale-wechat-browser"><Result status="info"
    title={text('请在默认浏览器中打开', 'Open this link in your default browser')}
    subTitle={text(`${name} 内置浏览器无法完成资源激活和展示。请点击右上角“···”，选择“在浏览器中打开”，再输入激活码。`,
      `${name}'s embedded browser cannot activate or display this resource. Tap “···” in the top right, choose “Open in browser”, then enter the activation code.`)}
  /></div>;
};
export default SaleBrowserNotice;
